export const SEND_BULK_SMS_START = 'SEND_BULK_SMS_START';
export const SEND_BULK_SMS_SUCCESS = 'SEND_BULK_SMS_SUCCESS';
export const SEND_BULK_SMS_ERROR = 'SEND_BULK_SMS_ERROR';
